import { render, staticRenderFns } from "./addVehicle.vue?vue&type=template&id=c6cfb0b8&scoped=true&"
import script from "./addVehicle.vue?vue&type=script&lang=js&"
export * from "./addVehicle.vue?vue&type=script&lang=js&"
import style0 from "./addVehicle.vue?vue&type=style&index=0&id=c6cfb0b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cfb0b8",
  null
  
)

export default component.exports